/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type { ComponentLike } from '@glint/template';

interface BvConnectedSignature {
  Args: {
    left?: ComponentLike;
    right?: ComponentLike;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const BvConnectedComponent = templateOnlyComponent<BvConnectedSignature>();

export default BvConnectedComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvConnected: typeof BvConnectedComponent;
    'bv-connected': typeof BvConnectedComponent;
  }
}
